<template lang="pug">
  v-container(fluid )
    v-layout(row wrap)
      v-flex(xs12)
        div.display-1 Please sign in using on of the following methods
      v-flex(xs12 justify-center)
        div#firebaseui-auth-container
</template>
<script>
// const firebase = () => import('firebase')
import firebase from "firebase";
import * as firebaseui from "firebaseui";
export default {
  mounted() {
    var uiConfig = {
      signInSuccessUrl: "/cart",
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    };
    var ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

